import styled from '@emotion/styled'

export const PaginationContainer = styled.div`
  text-align: center;
`
